import React from 'react'
import Slider from 'app/theme/slider'
import styles from './Testimonials.module.css'
import { ChevronRight, ChevronLeft } from 'react-feather'

export default function Testimonials({
  heading,
  items = [],
  buttonText,
  buttonAction,
  buttonUrl,
}) {
  return (
    <div className="bg-white py-10 md:py-24 lg:py-32">
      <div className="container">
        <h2 className={styles.heading}>
          {heading}
        </h2>
      </div>
      <Slider
        className={styles.slider}
        slidesToShow={2}
        slidesToScroll={1}
        arrows={true}
        dots={true}
        infinite={true}
        prevArrow={<PrevArrow />}
        nextArrow={<NextArrow />}
        centerMode={true}
        responsive={[
          {
            breakpoint: 1400,
            settings: {
              slidesToShow: 1,
              arrows: true,
            },
          },
          {
            breakpoint: 1200,
            settings: {
              slidesToShow: 1,
              arrows: false,
            },
          },
        ]}
      >
        {items.map((item, key) => (
          <div key={key} className={styles.slide}>
            <div className="mx-auto bg-gray-200 rounded-lg p-6 md:flex gap-6 md:gap-10 text-black">
              {item.imageUrl && (
                <div className={styles.imageContainer}>
                  <img
                    src={item.imageUrl}
                    title={item.imageTitle}
                    alt={item.imageTitle}
                    className={styles.image}
                  />
                </div>
              )}
              <div className="flex-1 flex flex-col gap-5 justify-center">
                <p className="italic text-lg leading-tight md:text-2xl">
                  {item.testimonial}
                </p>
                <div className="flex gap-6 pt-2">
                  {item.eaterCount > 0 && (
                    <div className="flex gap-3">
                      <svg width="20" height="24" viewBox="0 0 20 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M18.3346 0.333984C18.5763 0.333995 18.8098 0.421508 18.9919 0.58034C19.174 0.739173 19.2924 0.958579 19.3253 1.19798L19.3346 1.33398V22.6673C19.3346 22.9207 19.2383 23.1646 19.0653 23.3497C18.8924 23.5348 18.6556 23.6474 18.4028 23.6647C18.15 23.682 17.9001 23.6026 17.7036 23.4427C17.507 23.2829 17.3785 23.0543 17.344 22.8033L17.3346 22.6673V16.0007H14.3346C14.093 16.0006 13.8595 15.9131 13.6774 15.7543C13.4953 15.5955 13.3768 15.3761 13.344 15.1367L13.3346 15.0007V5.33398C13.3346 4.0079 13.8614 2.73613 14.7991 1.79845C15.7368 0.860769 17.0086 0.333984 18.3346 0.333984ZM10.3346 0.333984C10.5763 0.333995 10.8098 0.421508 10.9919 0.58034C11.174 0.739173 11.2924 0.958579 11.3253 1.19798L11.3346 1.33398V6.66732C11.3346 9.27132 9.46797 11.438 7.0013 11.9073V22.6673C7.00122 22.9207 6.90498 23.1646 6.732 23.3497C6.55903 23.5348 6.32224 23.6474 6.06946 23.6647C5.81669 23.682 5.56678 23.6026 5.37024 23.4427C5.17369 23.2829 5.04517 23.0543 5.01063 22.8033L5.0013 22.6673V11.9073C3.82899 11.6832 2.76568 11.0725 1.98133 10.1728C1.19699 9.2732 0.736907 8.13657 0.674636 6.94465L0.667969 6.66732V1.33398C0.668046 1.08062 0.764295 0.83673 0.937265 0.651595C1.11024 0.466461 1.34703 0.353886 1.59981 0.336617C1.85258 0.319347 2.10249 0.398671 2.29903 0.558561C2.49558 0.718451 2.6241 0.946984 2.65864 1.19798L2.66797 1.33398V6.66732C2.66797 8.16065 3.6493 9.42332 5.0013 9.84865V1.33398C5.00138 1.08062 5.09763 0.83673 5.2706 0.651595C5.44357 0.466461 5.68037 0.353886 5.93314 0.336617C6.18592 0.319347 6.43582 0.398671 6.63237 0.558561C6.82891 0.718451 6.95743 0.946984 6.99197 1.19798L7.0013 1.33398V9.84732C7.63756 9.6468 8.19909 9.26012 8.61337 8.73723C9.02764 8.21433 9.27563 7.57925 9.3253 6.91399L9.33463 6.66732V1.33398C9.33463 1.06877 9.43999 0.814414 9.62753 0.626877C9.81507 0.439341 10.0694 0.333984 10.3346 0.333984ZM17.3346 14.0007V2.50465C16.7865 2.69864 16.3065 3.04758 15.9529 3.50912C15.5993 3.97066 15.3873 4.52494 15.3426 5.10465L15.3346 5.33398V14.0007H17.3346Z" fill="#03ABEC"/>
                      </svg>
                      <span>
                        {item.eaterCount} <span className="font-light">Eaters</span>
                      </span>
                    </div>
                  )}
                  {item.truckCount > 0 && (
                    <div className="flex gap-3">
                      <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M12.0013 22.6667C12.0013 23.3739 11.7203 24.0522 11.2203 24.5523C10.7202 25.0524 10.0419 25.3333 9.33464 25.3333C8.62739 25.3333 7.94911 25.0524 7.44902 24.5523C6.94892 24.0522 6.66797 23.3739 6.66797 22.6667C6.66797 21.9594 6.94892 21.2811 7.44902 20.781C7.94911 20.281 8.62739 20 9.33464 20C10.0419 20 10.7202 20.281 11.2203 20.781C11.7203 21.2811 12.0013 21.9594 12.0013 22.6667ZM12.0013 22.6667H20.0013M20.0013 22.6667C20.0013 23.3739 20.2823 24.0522 20.7824 24.5523C21.2824 25.0524 21.9607 25.3333 22.668 25.3333C23.3752 25.3333 24.0535 25.0524 24.5536 24.5523C25.0537 24.0522 25.3346 23.3739 25.3346 22.6667C25.3346 21.9594 25.0537 21.2811 24.5536 20.781C24.0535 20.281 23.3752 20 22.668 20C21.9607 20 21.2824 20.281 20.7824 20.781C20.2823 21.2811 20.0013 21.9594 20.0013 22.6667Z" stroke="#03ABEC" strokeLinecap="round" strokeLinejoin="round"/>
                        <path d="M25.3333 22.6663H26.6667C27.0203 22.6663 27.3594 22.5259 27.6095 22.2758C27.8595 22.0258 28 21.6866 28 21.333V15.2957C28 14.8819 27.9037 14.4738 27.7187 14.1037L26.4387 11.5437C26.1064 10.8794 25.5958 10.3207 24.964 9.9303C24.3321 9.53985 23.6041 9.33303 22.8613 9.33301H8C6.93913 9.33301 5.92172 9.75444 5.17157 10.5046C4.42143 11.2547 4 12.2721 4 13.333V21.333C4 21.6866 4.14048 22.0258 4.39052 22.2758C4.64057 22.5259 4.97971 22.6663 5.33333 22.6663H6.66667M4 15.9997H28M20 15.9997V9.33301M8 7.33301C8 6.80257 8.21071 6.29387 8.58579 5.91879C8.96086 5.54372 9.46957 5.33301 10 5.33301H19.3333C19.8638 5.33301 20.3725 5.54372 20.7475 5.91879C21.1226 6.29387 21.3333 6.80257 21.3333 7.33301C21.3333 7.86344 21.1226 8.37215 20.7475 8.74722C20.3725 9.12229 19.8638 9.33301 19.3333 9.33301H10C9.46957 9.33301 8.96086 9.12229 8.58579 8.74722C8.21071 8.37215 8 7.86344 8 7.33301Z" stroke="#03ABEC" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                      </svg>
                      <span>
                        {item.truckCount} <span className="font-light">Food Trucks</span>
                      </span>
                    </div>
                  )}
                </div>
                <div className="text-xl">
                  <div className="font-bold">
                    {item.personName}
                  </div>
                  <div className="font-light ">
                    {item.personTitle}
                  </div>
                </div>
              </div>
            </div>
          </div>
        ))}
      </Slider>
      {buttonUrl || buttonAction ? (
        <div className="flex justify-center mt-8 lg:mt-12">
          {buttonUrl ? (
            <a
              href={buttonUrl}
              className={['btn', styles.button]}
            >
              {buttonText}
              <ChevronRight className="mt-1 ml-1" />
            </a>
          ) : (
            <button
              type="button"
              className={['btn', styles.button]}
              onClick={buttonAction}
              children={buttonText}
            >
              {buttonText}
              <ChevronRight className="mt-1 ml-1" />
            </button>
          )}
        </div>
      ) : null}
    </div>
  )
}

function PrevArrow(props) {
  return (
    <button className={props.className} onClick={props.onClick}>
      <ChevronLeft size={34} className="text-white" />
    </button>
  )
}

function NextArrow(props) {
  return (
    <button className={props.className} onClick={props.onClick}>
      <ChevronRight size={34} className="text-white" />
    </button>
  )
}
